/**
 * Name: Video
 */

export default class Video {
  constructor(element) {
    this.element = element;
    this.wrapper = element.querySelector('.c-video__wrapper');
    this.button = element.querySelector('.c-video__button');
    this.figure = element.querySelector('.c-video__figure');
    this.videoID = this.wrapper?.dataset.videoid;
  }

  mount() {
    if (!this.wrapper || !this.videoID) return;

    this.button?.addEventListener('click', () => this.startVideo());
    this.figure?.addEventListener('click', () => this.startVideo());
  }

  createIframe() {
    const iframe = document.createElement('iframe');
    iframe.setAttribute('src', `https://www.youtube-nocookie.com/embed/${this.videoID}?enablejsapi=1&rel=0&origin=${window.location.origin}`);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

    iframe.addEventListener('load', () => {
      iframe.contentWindow?.postMessage(JSON.stringify({
        event: 'command',
        func: 'playVideo',
        args: [],
      }), '*');
    });

    return iframe;
  }

  launchVideo() {
    const target = this.wrapper.querySelector('iframe[src*="youtube"], .youtube_player, .tac_video_player')
      ?? this.wrapper.querySelector('.c-figure__embed');

    if (target?.matches('.c-figure__embed')) {
      target.innerHTML = '';
      target.appendChild(this.createIframe());
    } else if (target) {
      target.replaceWith(this.createIframe());
    }
  }

  startVideo() {
    this.button?.remove();
    this.figure?.remove();
    this.element.classList.remove('c-video--notplay');

    const tacManagesYoutube = typeof tarteaucitron !== 'undefined'
      && Array.isArray(tarteaucitron.job)
      && tarteaucitron.job.includes('youtube');

    if (!tacManagesYoutube || tarteaucitron.state?.youtube === true) {
      this.launchVideo();
    } else {
      const observer = new MutationObserver(() => {
        const tacIframe = this.wrapper.querySelector('iframe[src*="youtube"]');
        if (!tacIframe) return;
        observer.disconnect();
        tacIframe.replaceWith(this.createIframe());
      });

      observer.observe(this.wrapper, { childList: true, subtree: true });
    }
  }
}
